module.exports = __webpack_public_path__ + "img/Weapon_139.ead99fbc.png";